import routes from "../common/api-routes";
import {HttpAuthDelete, HttpAuthGet, HttpAuthPost, HttpAuthPutParamsPayload} from "../../../../core/services/common/HttpRequestBuilder";

const getGateList = (page, limit, status, type, location) => {
    let query_params = {
        page,
        limit,
        status,
        type,
        location,
    }
    let result = HttpAuthGet(routes.GET_GATE_LIST, query_params);
    return result;
}

const createGate = (port_uid, type, status, gateName, location) => {
    let payload = {
        port_uid,
        type,
        status,
        gateName,
        location,
    }
    let result = HttpAuthPost(routes.CREATE_GATE, payload);
    return result;
}

const viewGate = (gateUID) => {
    let query_params = {
        gateUID,
    }
    let result = HttpAuthGet(routes.VIEW_GATE, query_params);
    return result;
}

const updateGateStatus = (gateUID, status) => {
    let query_params = {
        gateUID,
        status,
    }
    let result = HttpAuthPutParamsPayload(routes.UPDATE_GATE_STATUS, query_params);
    return result;
}

const deleteGate = (gateUID) => {
    let query_params = {
        gateUID
    }
    let result = HttpAuthDelete(routes.DELETE_GATE, query_params);
    return result;
}

const filterGate = (parameters) => {
    let result = HttpAuthGet(routes.FILTER_GATE, parameters);
    return result;
}

const GateService = {
    getGateList,
    createGate,
    viewGate,
    updateGateStatus,
    deleteGate,
    filterGate: filterGate
}

export default GateService


